export default __webpack_public_path__ + "static/media/tom-lamb.101aa8ee.svg";